// extracted by mini-css-extract-plugin
export default {"container":"ScanQr_container__AkjLB","qrScanner":"ScanQr_qrScanner__VLhQL","qrScannerVideo":"ScanQr_qrScannerVideo__9iTKP","qrScannerOverlay":"ScanQr_qrScannerOverlay__ZYs5I"};